import { Button, Dialog, DialogContent, Tooltip } from "@mui/material";
import React, { useState } from "react";
import InvoicesFilter from "../../../components/element/InvoicesFilter";

const InvoicesTabBar = ({
  selectedTab,
  setSelectedTab,
  onClickApply,
  onClickClear,
  bankConfig,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [openBankDetailsDialog, setOpenBankDetailsDialog] = useState(false);

  const handleTabClick = (index) => {
    setSelectedTab(index);
  };

  return (
    <div>
      <div className="invoices-tab-bar-container">
        <div className="invoices-tab-bar-button-container">
          <Tooltip title="Invoices that have been generated but not yet marked as paid.">
            <Button
              variant="contained"
              color={selectedTab === 0 ? "secondaryButton" : "disableGray"}
              onClick={() => handleTabClick(0)}
            >
              New Invoice
            </Button>
          </Tooltip>
          <Tooltip title="Invoices that have been fully paid by the user or Payment from customer pending reconciliation with corresponding invoices are listed here.">
            <Button
              variant="contained"
              color={selectedTab === 1 ? "secondaryButton" : "disableGray"}
              onClick={() => handleTabClick(1)}
            >
              Payment
            </Button>
          </Tooltip>

          <Tooltip title="Invoices past their due date that are still unpaid.">
            <Button
              variant="contained"
              color={selectedTab === 2 ? "secondaryButton" : "disableGray"}
              onClick={() => handleTabClick(2)}
            >
              Overdue
            </Button>
          </Tooltip>
        </div>
        <div className="invoices-tab-bar-button-container">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setOpenBankDetailsDialog(true)}
          >
            Bank details
          </Button>
          <Button
            variant="contained"
            color={showFilter ? "secondaryButton" : "disableGray"}
            onClick={() => setShowFilter(!showFilter)}
          >
            Filters
          </Button>
        </div>
      </div>
      {showFilter && (
        <InvoicesFilter
          selectedTab={selectedTab}
          onClickApply={onClickApply}
          onClickClear={onClickClear}
        />
      )}

      <Dialog
        open={openBankDetailsDialog}
        onClose={() => setOpenBankDetailsDialog(false)}
      >
        <DialogContent>
          <div className="bank-details-container">
            <div className="bank-details-section">
              <h2>BSD Banking Details</h2>
              <div className="bank-details-content">
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Account Name:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.bsdAccountName}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Bank Name:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.bsdBankName}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Branch Number:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.bsdBranchNumber}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Account Number:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.bsdAccountNumber}
                  </span>
                </div>
              </div>
            </div>

            <div className="bank-details-section">
              <h3>USD Banking Details</h3>
              <div className="bank-details-content">
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Intermediary Bank:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdIntermediaryBank}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">ABA:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdAba}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">SWIFT:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdSwift}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">
                    For Credit to Account:
                  </span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdCreditAccount}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Beneficiary Bank:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdBeneficiaryBank}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">
                    Bahamas Transit Number:
                  </span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdBahamasTransitNumber}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Account Number:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdAccountNumber}
                  </span>
                </div>
                <div className="bank-detail-row">
                  <span className="bank-detail-label">Beneficiary Name:</span>
                  <span className="bank-detail-value">
                    {bankConfig?.data?.usdBeneficiaryName}
                  </span>
                </div>
              </div>
            </div>
            <Button
              variant="contained"
              color="secondaryButton"
              className="done-button"
              onClick={() => setOpenBankDetailsDialog(false)}
            >
              Done
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default InvoicesTabBar;
